import { createStore } from 'vuex'
import router from '@/router'
import qs from 'qs'

// 获取当前登录类型
const getCurrentLoginType = () => {
  return sessionStorage.getItem('currentLoginType');
};

export default createStore({
  state: {
    hasRoutes: false,
    editableTabsValue: '/index',
    editableTabs: [
      // {
      //   title: '首页',
      //   name: '/index'
      // }
    ],
    // 添加工资表相关状态
    salaryData: {
      createMethod: '',
      projectName: '',
      salaryMonth: '',
      currentStep: 1  // 默认第一步
    },
    submitSalary:null,
  },
  getters: {
    GET_TOKEN: state => {
      const loginType = getCurrentLoginType();
      return sessionStorage.getItem(`${loginType}_token`);
    },
    GET_MENULIST: state => {
      const loginType = getCurrentLoginType();
      console.log("再次登录显示的是前一个登录类型吗？=" + loginType);
      return JSON.parse(sessionStorage.getItem(`${loginType}_menuList`));
    },
    // 添加获取工资表数据的getter
    GET_SALARY_DATA: state => {
      return state.salaryData;
    },
    getSubmitSalary: state => state.submitSalary
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      const loginType = getCurrentLoginType();
      sessionStorage.setItem(`${loginType}_token`, token);
    },
    RESET_TOKEN: (state) => {
      const loginType = getCurrentLoginType();
      sessionStorage.setItem(`${loginType}_token`, "");
    },
    SET_MENULIST: (state, menuList) => {
      const loginType = getCurrentLoginType();
      sessionStorage.setItem(`${loginType}_menuList`, JSON.stringify(menuList));
    },
    ADD_TABS: (state, tab) => {
      if (state.editableTabs.findIndex(e => e.name === tab.path) === -1) {
        state.editableTabs.push({
          title: tab.name,
          name: tab.path
        });
      }
      state.editableTabsValue = tab.path;
    },
    SET_ACTIVE_TAB(state, tabName) {
      state.activeTab = tabName
    },
    RESET_TABS: (state) => {
      state.editableTabsValue = '/index';
      state.editableTabs = [
        {
          title: '首页',
          name: '/index'
        }
      ];
    },
    SET_ROUTES_STATE: (state, hasRoutes) => {
      state.hasRoutes = hasRoutes;
    },
    // 新增重置菜单状态的 mutation
    RESET_MENU_STATE: (state) => {
      // 重置 editableTabs 相关状态
      state.editableTabsValue = '/index';
      state.editableTabs = [
        {
          title: '首页',
          name: '/index'
        }
      ];
      // 重置路由状态
      state.hasRoutes = false;
      // 同时重置工资表数据
      state.salaryData = {
        createMethod: '',
        projectName: '',
        salaryMonth: '',
        currentStep: 1
      };

    },

    // 添加设置工资表数据的mutation
    setSalaryData: (state, payload) => {
      state.salaryData = { ...state.salaryData, ...payload };
    },
    setSubmitSalary(state, submitData) {
      state.submitSalary = submitData;
    },
    // 添加单独设置步骤的mutation
    setCurrentStep: (state, step) => {
      state.salaryData.currentStep = step;
    },
    TOGGLE_SIDEBAR(state) {
      state.isSidebarCollapsed = !state.isSidebarCollapsed;
    },
    SET_SIDEBAR_COLLAPSED(state, value) {
      state.isSidebarCollapsed = value;
    },
  },
  actions: {
    // 安全退出
    logout() {
      const loginType = getCurrentLoginType();
      sessionStorage.removeItem(`${loginType}_token`);
      sessionStorage.removeItem(`${loginType}_menuList`);
      sessionStorage.removeItem(`${loginType}_currentUser`); // 假设也有用户信息需要清除
      this.commit('RESET_MENU_STATE'); // 退出时也重置菜单状态
      router.replace('/loginfirst');
    }
  },
  modules: {}
});
